import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { SessionService } from 'src/app/services/session.service';
import { environment } from 'src/environments/environment';
import { ISelfAuditDataModel } from '../models/veg-wizard-models';
import { Logger } from './logger-service';

@Injectable({
  providedIn: 'root'
})
export class SelfAuditService {
  constructor(
    private http: HttpClient,
    private logger: Logger,
    private sessionService: SessionService
  ) {}

  setSelfAudit$(model: ISelfAuditDataModel, sessionId: string | undefined): Observable<boolean> {
    
    return this.http.post<boolean>(
      `${environment.apiUrl}/session/self-audit`, { ...model, sessionKey: sessionId })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          this.logger.error('setSelfAudit error', err);
          return of(false)
        }),
        map(() => true) // return true, as it should be HttpStatusCode OK
      );
  }
}
